import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Catches render errors inside one tab/panel so a bad record never blanks
 *  the whole page. Shows the error text so it can be reported. */
export default class PanelErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("[PanelErrorBoundary]", this.props.name || "panel", error, info?.componentStack); }
  componentDidUpdate(prev) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="border border-rose-200 bg-rose-50 rounded-lg p-4 text-sm text-rose-900 space-y-2" data-testid="panel-error-boundary">
        <p className="font-semibold flex items-center gap-2"><AlertTriangle className="w-4 h-4" />This {this.props.name || "panel"} hit an error and couldn't render.</p>
        <p className="text-xs font-mono break-all">{String(this.state.error?.message || this.state.error)}</p>
        <p className="text-xs">The rest of the page is unaffected. Please report this via "Report a bug" with the message above.</p>
        <Button size="sm" variant="outline" onClick={() => this.setState({ error: null })} data-testid="panel-error-retry"><RefreshCw className="w-3.5 h-3.5 mr-1" />Try again</Button>
      </div>
    );
  }
}
